import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import {
  type PendingOrganizationDeletion,
  pendingOrganizationDeletionSchema,
} from '@borradh-workspace/contracts';
import { queryOptions } from '@tanstack/react-query';
export const pendingDeletionQuery = (userId: string) =>
  queryOptions({
    queryKey: queryKeys.privacy.pendingOrganizationDeletion(userId),
    staleTime: 30_000,
    retry: false,
    queryFn: () =>
      apiClient.get<PendingOrganizationDeletion>(
        'organizations/pending-deletion',
        { schema: pendingOrganizationDeletionSchema }
      ),
  });
